<template>
  <div>
    <div class="card">
      <div class="img-container" @click="toDetail(v_data)">
        <!-- <img  :src="base + v.Path" alt="" /> -->
        <el-image :src="v_data.Url" lazy fit="cover"></el-image>
      </div>
      <div class="bottom-container">
        <!--        <div class="vote-btn">-->
        <!--          <el-button type="primary" size="mini" @click="toDetail(v_data)">{{ $t("lang.Join") }}</el-button>-->
        <!--        </div>-->
        <h4>
          <span>{{ v_data.Title }}</span>
          <span>                  <img v-if="chain == 'ETH'"  :src="require('@/assets/img/nft.svg')" style="max-width: 18px;max-height: 18px;width: auto;height: auto;"/>
                  <img v-else-if="chain == 'CFX'" :src="require('@/assets/img/conflux_logo_only.png')" style="max-width: 18px;max-height: 18px;width: auto;height: auto;"/>

            {{ v_data.nft_amount }}</span>
        </h4>
        <p class="row">
          <!--          <span class="Owner">{{ v_data.owner_name }}</span>-->
          <i class="el-icon-alarm-clock"></i>
          <span :class="{ closed: Timestatus === 'Closed' }">{{ Timestatus }}</span>
        </p>
        <!-- 票数 -->
        <!--          TODO ADD IMAGE FOR UP AND DOWN-->
        <div class="progress-container">
          <div class="icon-wraper">
            <img src="@/assets/img/icon-sm.svg" alt="left icon" class="progress-icon" />
            <div class="hover-count">{{ v_data.l_count }}</div>
          </div>
          <div class="progress">
            <span class="progressing" :style="'width:' + v_data.Rate * 100 + '%'" ></span>
          </div>
          <div class="icon-wraper">
            <div class="hover-count">{{ v_data.r_count }}</div>
            <img src="@/assets/img/icon-k-gray.svg" alt="right icon" class="progress-icon" />
          </div>
        </div>
        <!-- 状态，收藏爱心 -->
        <div class="status-Collect">
          <p>
            <!-- Additional content if needed -->
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { countDownTime } from "@/config";

export default {
  props: {
    chain: {
      type: String,
      default: "ETH",
    },
    v_data: {
      type: Object,
    },
  },
  data() {
    return {
      currentTime: new Date().getTime(),
    };
  },
  computed: {
    Timestatus() {
      let endTime = this.v_data.start_time * 1000 + countDownTime * 1000;
      let time = endTime - this.currentTime;
      let status;
      if (time < 0) {
        status = this.$t("lang.Closed");
      } else {
        let hours = Math.floor(time / (1000 * 60 * 60));
        let minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((time % (1000 * 60)) / 1000);
        status =
            (hours > 9 ? hours : "0" + hours) +
            ":" +
            (minutes > 9 ? minutes : "0" + minutes) +
            ":" +
            (seconds > 9 ? seconds : "0" + seconds);
      }
      return status;
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      this.currentTime = new Date().getTime();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    toDetail(item) {
      console.log("gotoDetail", item);
      this.$router.push({ name: "nftDetail", query: { tokenID: item.asset_id, id: item.id } });
    },
  },
};
</script>

<style scoped lang="less">
.card {
  li {
    width: 24%;
    //background-color: #F8F8FF;
    border-radius: 5%;
    overflow: hidden;
    margin-right: 1.25%;
    margin-bottom: 15px;
    cursor: pointer;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 2px 0 rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    .img-container {
      height: 288px;
      background: transparent;
      overflow: hidden;
      .el-image {
        height: 100%;
        width: 100%;
        border-radius: 2px;
        transition: all 0.2s ease;
        &:hover {
          // transform: translateY(-8px);
          transform: scale(1.1);
        }
      }
    }
    &:hover {
      transform: translateY(-3px);
      box-shadow: 2px 8px 16px 2px rgba(0, 0, 0, 0.3), 1px 12px 4px 1px rgba(0, 0, 0, 0.2);
      .img-container {
        img {
          transform: translateY(-8px);
        }
      }
    }
    .bottom-container {
      h4 {
        justify-self: center;
        width: 90%;
        font-size: 15px;
        display: flex;
        justify-content: space-between;
        line-height: 28px;
        & > span:last-child {
          font-size: 13px;
          font-weight: normal;
        }
      }
      .gray {
        color: #666;
      }
      p {
        display: flex;
        justify-self: center;
        width: 90%;
        justify-content: space-between;
        line-height: 24px;
        & > span {
          display: flex;
          align-items: center;
          font-weight: 600;
          font-size: 14px;
        }
        .Owner {
          color: #666;
          font-weight: 500;
        }
      }
      img {
        width: 20px;
      }
      // 票数进度条
      .progress-container {
        display: flex;
        justify-content: center;
        .icon-wraper {
          position: relative;
          .hover-count {
            display: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 18px;
            color: #fff;
          }
          .progress-icon {
            width: 25px;
            height: 25px;
            margin-left: 10px;
            margin-right: 10px;
            transition: opacity 0.2s;
          }
        }
        .progress {
          margin-top: 5px;
          margin-bottom: 5px;
          width: 70%;
          height: 15px;
          display: flex;
          align-items: center;
          justify-self: center;
          border-radius: 8px;
          border: 1px solid #7d6fff;
          span {
            height: 15px;
            display: inline-block;
            background: #7d6fff;
            border-radius: 7.5px;
          }
        }
      }
      // 状态和收藏爱心
      .status-Collect {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0px;
        justify-self: center;
        width: 88.5%;
        .el-icon-alarm-clock {
          align-self: center;
          transform: scale(1.3);
          display: inline-block;
        }
        img {
          width: 25px;
        }
        p {
          position: relative;
          bottom: 0;
          width: 100%;
          text-align: center;
          span {
            text-align: center;
            color: #211522;
            &.closed {
              color: #333;
            }
          }
        }
      }
      // When hovering the entire bottom-container,
      // hide the small icons and show the vote counts.
      &:hover {
        background: linear-gradient(90deg, #f26aff, #7d6fff);
        span {
          color: #fff;
        }
        .progress-container {
          .progress {
            border: 2px solid #fff;
            z-index: 20;
            span {
              background: #fff;
              z-index: 1;
            }
          }
          .icon-wraper {
            .progress-icon {
              opacity: 0;
            }
            .hover-count {
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>
